import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PurchasableItem from './purchasable-item-model'
import {
  CreatePurchasableItemAsync,
  DeletePurchasableItemAsync,
  LoadPurchasableItemsAsync,
} from './purchasableItem-thunk'
const initialState: purchasableItemSliceState = {
  purchasableItem: [],
  selected_purchasableItem: '',
  is_loading_purchasableItem: false,
  is_creating_purchasableItem: false,
  is_deleting_purchasableItem: false,
}
export interface purchasableItemSliceState {
  purchasableItem: PurchasableItem[]
  selected_purchasableItem?: string
  is_loading_purchasableItem: boolean
  is_creating_purchasableItem: boolean
  is_deleting_purchasableItem: boolean
}
export const purchasableItemSlice = createSlice({
  name: 'purchasableItem',
  initialState,
  reducers: {
    setSelectedpurchasableItem: (state, action) => {
      state.selected_purchasableItem = action.payload
    },
    clearStatepurchasableItem: (state) => {
      state.purchasableItem = []
      state.is_loading_purchasableItem = false
      state.is_creating_purchasableItem = false
      state.is_deleting_purchasableItem = false
    },
    mergepurchasableItem: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_purchasableItem = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.purchasableItem = merge(state.purchasableItem, payload) as any
        }
      }
    },

    add_purchasableItem: (state, action) => {
      if (action.payload) {
        state.purchasableItem = [...state.purchasableItem, action.payload]
      }
    },
    set_purchasableItem: (state, action) => {
      let { key, value, id } = action.payload
      state.purchasableItem = state.purchasableItem.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPurchasableItemsAsync.pending, (state) => {
      state.is_loading_purchasableItem = true
    })
    builder.addCase(LoadPurchasableItemsAsync.fulfilled, (state, action) => {
      state.is_loading_purchasableItem = false
      if (action.payload) {
        state.purchasableItem = action.payload
      }
    })
    builder.addCase(LoadPurchasableItemsAsync.rejected, (state) => {
      state.is_loading_purchasableItem = false
    })
    builder.addCase(CreatePurchasableItemAsync.pending, (state) => {
      state.is_creating_purchasableItem = true
    })
    builder.addCase(CreatePurchasableItemAsync.fulfilled, (state) => {
      state.is_creating_purchasableItem = false
    })
    builder.addCase(CreatePurchasableItemAsync.rejected, (state) => {
      state.is_creating_purchasableItem = false
    })
    builder.addCase(DeletePurchasableItemAsync.pending, (state) => {
      state.is_deleting_purchasableItem = true
    })
    builder.addCase(DeletePurchasableItemAsync.fulfilled, (state, action) => {
      state.is_deleting_purchasableItem = false
      if (state.purchasableItem) {
        state.purchasableItem = state.purchasableItem.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePurchasableItemAsync.rejected, (state) => {
      state.is_deleting_purchasableItem = false
    })
  },
})

export const {
  clearStatepurchasableItem,
  setSelectedpurchasableItem,
  set_purchasableItem,
  mergepurchasableItem,
  add_purchasableItem,
} = purchasableItemSlice.actions

export const get_purchasableItem =
  (id?: string) =>
  (state: {
    purchasableItem: {
      purchasableItem: PurchasableItem[]
    }
  }): PurchasableItem | null => {
    let temp = state?.purchasableItem?.purchasableItem?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.purchasableItem?.purchasableItem[0] || null
  }
export const get_selected_purchasableItem = (state: {
  purchasableItem: purchasableItemSliceState
}): PurchasableItem | null => {
  let id = state?.purchasableItem?.selected_purchasableItem
  let temp = state?.purchasableItem?.purchasableItem?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_purchasableItem = (state: {
  purchasableItem: {
    purchasableItem: PurchasableItem[]
  }
}): PurchasableItem[] => {
  let temp = state?.purchasableItem?.purchasableItem
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_purchasableItem_busy = (state: {
  purchasableItem: purchasableItemSliceState
}) => {
  return (
    state?.purchasableItem.is_deleting_purchasableItem ||
    state?.purchasableItem.is_loading_purchasableItem ||
    state?.purchasableItem.is_creating_purchasableItem
  )
}
export const is_deleting_purchasableItem_busy = (state: {
  purchasableItem: purchasableItemSliceState
}) => {
  return state?.purchasableItem.is_deleting_purchasableItem
}
export const is_loading_purchasableItem_busy = (state: {
  purchasableItem: purchasableItemSliceState
}) => {
  return state?.purchasableItem.is_loading_purchasableItem
}
export const is_creating_purchasableItem_busy = (state: {
  purchasableItem: purchasableItemSliceState
}) => {
  return state?.purchasableItem.is_creating_purchasableItem
}

export default purchasableItemSlice.reducer
